import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  getInventoryLedgerList(context, payload) {
    if (payload.id !== undefined) {
      return axios
        .get(`/api/fulfillment/inventory_ledger/list?client_id=${payload.id}`, {
          params: payload,
        })
        .then((res) => res.data);
    } else {
      return axios
        .get(`/api/fulfillment/inventory_ledger/list`, {
          params: payload,
        })
        .then((res) => res.data);
    }
  },
  getShelfwiseList(context, payload) {
    if (payload.id !== undefined) {
      return axios
        .get(
          `/api/fulfillment/inventory_shelfwise/list?client_id=${payload.id}`,
          {
            params: payload,
          }
        )
        .then((res) => res.data);
    } else {
      return axios
        .get(`/api/fulfillment/inventory_shelfwise/list`, {
          params: payload,
        })
        .then((res) => res.data);
    }
  },
  getInventoryList(context, payload) {
    if (payload.id !== undefined) {
      return axios
        .get(
          `/api/fulfillment/inventory_snapshot/list?client_id=${payload.id}`,
          {
            params: payload,
          }
        )
        .then((res) => res.data);
    } else {
      return axios
        .get(`/api/fulfillment/inventory_snapshot/list`, {
          params: payload,
        })
        .then((res) => res.data);
    }
  },
  getB2bInventoryList(_, payload) {
    return axios
      .get(`/api/fulfillmentbb/b2b_inventory`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadb2bInventory(_, payload) {
    return axios
      .get(`/api/fulfillmentbb/b2b_inventory_download`, {
        responseType: "blob",
        params: payload,
      })
      .then((res) => res);
  },
  downloadInventory(_, payload) {
    return axios
      .get(
        `/api/fulfillment/inventory_snapshot/download?client_id=${payload.id}`,
        {
          responseType: "blob",
          params: payload,
        }
      )
      .then((res) => res);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
